<template>
  <div class="flex flex-col gap-5 min-h-96">
    <div class="flex gap-4">
      <div class="h-24 w-24 flex grow-0 shrink-0 border rounded-md">
        <NuxtImg :src="thumbnail" class="max-h-full max-w-full" quality="90" loading="lazy" @error="setDefaultImage" :alt="data.name" :title="data.name"/>
      </div>
      <div class="flex flex-col gap-0.5">
        <p class="line-clamp-2">{{ data.name }}</p>
        <p class="text-sm line-clamp-2 text-gray-500">{{ data.detail.summary }}</p>
        <span class="text-md font-semibold" v-if="pricing.price > 0">&#8377; {{parseFloat(pricing.price).toFixed(2)  }}</span>
      </div>
    </div>
    <!-- <div class="flex justify-end">
      <span class="text-red-500 text-md font-bold" @click="clearAllSelections">
        clear all
      </span>
    </div> -->
    <div class="flex flex-col gap-4 h-48 overflow-y-scroll" v-if="!isFetchingCompleted">
      <div class="text-gray-500 text-md text-center mx-auto py-12">
        <UIcon name="i-heroicons-arrow-path" />
        Loading
      </div>
    </div>
    <div class="flex flex-col gap-4 min-h-48 max-h-96 overflow-y-scroll" v-else>
      <div class="" v-for="(item, index) in customizationList" :key="index">
        <div class="flex flex-col border rounded-xl " v-if="item.min_count === 1 && item.max_count === 1">
          <div class="bg-white px-4 py-2 rounded-xl">
            <p class="text-black text-md">
              {{ item.name }}
              <!-- <span v-if="item.new_config.min === 0" class="text-sm text-gray-500">(Optional)</span> -->
              <!-- <span v-if="item.min_count > 0" class="text-xl text-red-500">*</span> -->
              <span v-if="item.min_count > 0" class="bg-orange-500 text-white text-xs px-2 py-1 ml-2 rounded-md">
                REQUIRED
              </span>
            </p>
            <p class="text-gray-500 text-xs">
              Select any {{ item.max_count }} item
            </p>
          </div>
          <div class="bg-gray-100 px-4 py-2">
            <URadioGroup v-model="selected[item.id]" :options="item.options.map(option => ({...option,
                disabled: option.inventory_quantity === 0 || option.status === 'disable' 
              }))" option-attribute="name"
              value-attribute="id" :ui="{ wrapper: 'my-2 flex justify-end w-full', fieldset: 'w-full' } "
              :ui-radio="{ wrapper: 'py-2 flex flex-row-reverse gap-4 w-full justify-between', base: 'h-5 w-5 shrink-0', help: 'text-red-500', inner: 'w-full' }">
              <template #label="{ option }">
                <div class="inline-flex justify-between w-full">
                  <div class="inline-flex items-start gap-2 grow">
                    <div class="inline-flex items-start gap-1 shrink-0" v-if="option.food_type === 'veg'">
                      <V3ImageComponent src="icons/veg.png" class="h-5 w-5" />
                    </div>
                    <div class="inline-flex items-start gap-1 shrink-0" v-if="option.food_type === 'egg'">
                      <V3ImageComponent src="icons/egg.png" class="h-5 w-5" />
                    </div>
                    <div class="inline-flex items-start gap-1 shrink-0"
                      v-if="option.food_type === 'nonveg' || option.food_type === 'non_veg'">
                      <V3ImageComponent src="icons/nonveg.png" class="h-5 w-5" />
                    </div>
                    <div class="flex flex-col  items-start dark:text-gray-700">
                        <p class="line-clamp-2">{{ option.name }}</p>
                        <span v-if="option.inventory_quantity === 0" class="text-red-500">Sold Out</span>
                        <span v-else-if ="option.status === 'disable'" class="text-red-500">Currently Unavailable</span>
                    </div>
                  </div>

                  <div class="flex items-start dark:text-gray-700 shrink-0 grow-0">
                    <p v-if="Number(option.price) > 0">&#8377; {{ parseFloat(option.price).toFixed(2) }}</p>
                  </div>
                </div>
              </template>
            </URadioGroup>
          </div>
        </div>
        <div class="flex flex-col border rounded-xl" v-else>
          <div class="bg-white px-4 py-2 rounded-xl">
            <p class="text-black text-md">
              {{ item.name }}
              <span v-if="item.min_count === null || item.min_count === 0" class="text-sm text-gray-500">(Optional)</span>
              <span v-if="item.min_count > 0" class="bg-orange-500 text-white text-xs px-2 py-1 ml-2 rounded-md">
                REQUIRED
              </span>
            </p>
            <p class="text-gray-500 text-xs" v-if="item.min_count === null || item.min_count === 0 && item.max_count > 0">
              Select upto {{ item.max_count }} items
            </p>
            <p class="text-gray-500 text-xs" v-if="item.min_count > 0">
              Select at least {{ item.max_count }} items
            </p>
          </div>
          <div class="bg-gray-100 px-4 py-2">
            <div class="" v-for="(product, i) in item.options" :key="i">
              <UCheckbox v-model="selected[item.id]" :value="product.id"
                :ui="{ base: 'h-5 w-5', inner: '', wrapper: 'flex flex-row-reverse justify-between items-start gap-4 w-full py-2', inner: 'w-full' }"
                :disabled="product.inventory_quantity === 0 || product.status === 'disable' || isCheckboxDisabled(item.id, product.id)">
                <template #label>
                  <div class="inline-flex justify-between w-full flex-col">
                    <div class="inline-flex items-start gap-2 shrink-0">
                      <div class="inline-flex items-start gap-1 shrink-0" v-if="product.food_type === 'veg'">
                        <V3ImageComponent src="icons/veg.png" class="h-5 w-5" />
                      </div>
                      <div class="inline-flex items-start gap-1 shrink-0" v-if="product.food_type === 'egg'">
                        <V3ImageComponent src="icons/egg.png" class="h-5 w-5" />
                      </div>
                      <div class="inline-flex items-start gap-1 shrink-0"
                        v-if="product.food_type === 'non_veg' || product.food_type === 'nonveg'">
                        <V3ImageComponent src="icons/nonveg.png" class="h-5 w-5" />
                      </div>
                      <div class="flex flex-col items-start dark:text-gray-700">
                          <p class="line-clamp-2">{{ product.name }}</p>
                          <span v-if="product.inventory_quantity === 0" class="text-red-500">Sold Out</span>
                          <span v-else-if ="product.status === 'disable'" class="text-red-500">Currently Unavailable</span>

                      </div>
                    </div>
                    <div class="flex items-start dark:text-gray-700 shrink-0 mt-1 ml-5" >
                      <p v-if="Number(product.price) > 0">&#8377; {{ parseFloat(product.price).toFixed(2) }}</p>
                    </div>
                  </div>
                </template>
              </UCheckbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-between w-full md:justify-end items-center px-2">
      <div class="flex flex-col px-2 justify-between md:px-8 md:border-r-2 border-gray-300 grow-0 shrink-0">
        <h5 class="text-sm text-gray-500">Total</h5>
        <p class="text-md font-semibold">&#8377; {{ totalAmount }}</p>
      </div>
      <div class="px-4 md:w-1/2 shrink-0">
        <UButton color="primary" size="xl" block variant="outline" :ui="{ variant: { outline: 'bg-orange-50' } }" :disabled="isSubmitting"
          @click.stop="handleAddToCart">Add to Cart</UButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import shortHash from 'short-hash';

const runtimeConfig = useRuntimeConfig();
const cart = useCart();
const props = defineProps(['data']);
const emit = defineEmits(['close']);
const isFetchingCompleted = ref(false);
const customizations = ref(null);

onMounted(async () => {
  try {
    const { data: apiResult } = await useAPIHandler(
      'get',
      `/products/${props.data.provider.ukid}/${props.data.sku_id}/customizations`
    );

    customizations.value = apiResult;
    props.data.customizations = apiResult;
  } catch (error) {
    console.error('Failed to fetch customizations:', error);
    customizations.value = null;
  } finally {
    isFetchingCompleted.value = true;
  }
});

const pricing = usePriceBuilder(props.data);
const selected = ref({});
const tempselected = ref({});
const isSubmitting = ref(false);

const thumbnail = await useValidateThumbnailBuilder(props.data.images);

const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}

const isCheckboxDisabled = (groupId, productId) => {
  const selectedItems = selected.value[groupId] || [];
  const maxCount = customizationList.value.find(item => item.id === groupId)?.max_count || 0;
  return selectedItems.length >= maxCount && !selectedItems.includes(productId);
};

const totalAmount = computed(() => {
  let total = parseFloat(props.data.price) || 0; // Start with the base product price'

  Object.keys(selected.value).forEach(groupId => {
    const group = customizationList.value.find(item => item.id === groupId);

    if (group) {
      const selectedItems = selected.value[groupId];

      if (Array.isArray(selectedItems)) {
        // Multiple selections
        selectedItems.forEach(selectedId => {
          const option = group.options.find(opt => opt.id === selectedId);
          if (option && option.price) {
            total += parseFloat(option.price);
          }
        });
      } else {
        // Single selection
        const option = group.options.find(opt => opt.id === selectedItems);
        if (option && option.price) {
          total += parseFloat(option.price);
        }
      }
    }
  });

  return total.toFixed(2);
});


const clearAllSelections = () => {
  selected.value = {};
};


const customizationList = computed(() => {
  const list = [];

  const processGroup = (groupId) => {
    const matchedItem = customizations.value.customizations.find(item => item.id === groupId);
    if (matchedItem) {
      list.push(matchedItem);

      // Handle options and default selection
      if (matchedItem.options.length > 0) {
        const defaultOptions = matchedItem.options.filter(option => option.default.isDefault === 1);

        if (defaultOptions.length > 0) {
          if (matchedItem.max_count === 1 && matchedItem.min_count === 1) {
              if (defaultOptions[0].inventory_quantity === 0 && defaultOptions[0].max_quantity === 0) {
                // Find the next valid option with inventory_quantity > 0 and max_quantity > 0
                const nextValidOption = matchedItem.options.find(
                  option => option.inventory_quantity > 0 && option.max_quantity > 0
                );
                if (nextValidOption) {
                  selected.value[matchedItem.id] = nextValidOption.id;
                } else {
                  selected.value[matchedItem.id] = undefined;
                }
              } else {
                selected.value[matchedItem.id] = defaultOptions[0].id;
              }
              
          } else {
            selected.value[matchedItem.id] = defaultOptions.map(option => option.id);
          }

          // Process child addons group for all default options
          defaultOptions.forEach(defaultOption => {
            if (defaultOption.child_addons_group && Array.isArray(defaultOption.child_addons_group)) {
              defaultOption.child_addons_group.forEach(childGroupId => {
                processGroup(childGroupId);
              });
            }
          });
        } else {
          // No default options; fallback logic
          if (matchedItem.min_count > 0) {
           // selected.value[matchedItem.id] = matchedItem.max_count === 1 && matchedItem.min_count === 1 ? matchedItem.options[0].id  : [matchedItem.options[0].id];
           const availableOptions = matchedItem.options.filter(option => option.inventory_quantity > 0 && option.max_quantity > 0);
           if (availableOptions.length >= matchedItem.min_count) {
              selected.value[matchedItem.id] = matchedItem.max_count === 1 && matchedItem.min_count === 1 
                ? availableOptions[0].id 
                : availableOptions.slice(0, matchedItem.min_count).map(option => option.id);
            } else {
              selected.value[matchedItem.id] = matchedItem.max_count === 1 && matchedItem.min_count === 1 
                ? undefined 
                : [];
            }
          } else {
            selected.value[matchedItem.id] = matchedItem.max_count === 1 && matchedItem.min_count === 1 ? undefined : [];
          }
        }
      }
    }
  };

  if (customizations.value && Array.isArray(customizations.value.custom_group)) {
    customizations.value.custom_group.forEach(processGroup);
  } else {
    console.log('custom_group is undefined or not an array');
  }

  return list;
});


watch(selected.value, () => {
  if (tempselected) {
    console.log("OLD", tempselected.value)
    for (const groupId in tempselected.value) {
      if (!(groupId in selected.value)) {
        // If a group was removed entirely
        console.log(`Group ${groupId} was removed`);
        removeOldChildAddonGroups(groupId, tempselected.value[groupId]);
      } else if (tempselected.value[groupId] !== selected.value[groupId]) {
        // If the group exists in both but has a different selection
        console.log(`Group ${groupId} selection changed`);
        removeOldChildAddonGroups(groupId, tempselected.value[groupId]);
        addNewChildAddonGroups(groupId, selected.value[groupId]);
      }
    }
  }
  console.log("New", selected.value)

  for (const groupId in selected.value) {
    if (!(groupId in tempselected.value)) {
      // If a group was added
      console.log(`Group ${groupId} was added`);
      addNewChildAddonGroups(groupId, selected.value[groupId]);
    }
  }
});

const removeOldChildAddonGroups = (groupId, previousOptionId) => {
  const group = customizationList.value.find(item => item.id === groupId);
  if (group) {
    const previousItem = group.options.find(option => option.id === previousOptionId);
    if (previousItem && Array.isArray(previousItem.child_addons_group)) {
      const childGroupIdsToRemove = previousItem.child_addons_group;
      for (let i = customizationList.value.length - 1; i >= 0; i--) {
        const currentGroup = customizationList.value[i];
        if (childGroupIdsToRemove.includes(customizationList.value[i].id)) {
          console.log(`Removing item with ID: ${customizationList.value[i].id}`);
          customizationList.value.splice(i, 1);
          delete selected.value[currentGroup.id];
        }
      }
    }
  }
};

// Function to add new child addon groups based on the current selection
const addNewChildAddonGroups = (groupId, currentOptionId) => {
  const group = customizations.value.customizations.find(item => item.id === groupId);
  if (group) {
    const currentItem = group.options.find(option => option.id === currentOptionId);
    if (currentItem && Array.isArray(currentItem.child_addons_group)) {
      const childGroupIdsToAdd = currentItem.child_addons_group;
      childGroupIdsToAdd.forEach(childGroupId => {
        if (!customizationList.value.some(item => item.id === childGroupId)) {
          console.log(`Adding item with ID: ${childGroupId}`);

          // Find the index of the current group to insert after it
          const index = customizationList.value.findIndex(item => item.id === groupId);
          if (index !== -1) {
            // Find and add the child group after the current group
            const childGroup = customizations.value.customizations.find(item => item.id === childGroupId);
            if (childGroup) {
              customizationList.value.splice(index + 1, 0, childGroup);

              // Set the selected value for the added child group if it has a default option
              const defaultOption = childGroup.options.find(option => option.default.isDefault === 1);
              if (defaultOption) {
                selected.value[childGroup.id] = childGroup.max_count === 1 && childGroup.min_count === 1 ? defaultOption.id : [defaultOption.id];

                // Check for child addons of the default option
                if (Array.isArray(defaultOption.child_addons_group)) {
                  defaultOption.child_addons_group.forEach(grandchildGroupId => {
                    addNewChildAddonGroups(grandchildGroupId, defaultOption.id);
                  });
                }
              } else {
                selected.value[childGroup.id] = childGroup.max_count === 1 && childGroup.min_count === 1 ? undefined : [];
              }
            }
          }
        }
      });
    }
  }
  tempselected.value = { ...selected.value }
};

const handleAddToCart = async () => {
  if (isSubmitting.value) {
    console.warn('Add to Cart action is already in progress.');
    return; // Prevent further clicks
  }

  isSubmitting.value = true; // Block subsequent clicks

  try {
    await addToCart(); // Call the add-to-cart logic
  } catch (error) {
    console.error('Error adding to cart:', error);
  } 
};

const addToCart = async () => {
  const addons = [];

  // Iterate over each customization ID in selected.value
  for (const groupId in selected.value) {
    const selectedOptionIds = selected.value[groupId]; // Retrieve the selected option(s) for this group
    if (!selectedOptionIds || selectedOptionIds.length === 0) {
      continue; // Skip if no option is selected for this group
    }

    // Find the customization group in the customizations data
    const custItem = customizations.value.customizations.find((item) => item.id === groupId);
    if (!custItem || !custItem.options) {
      console.warn(`Customization group with ID ${groupId} not found or has no options.`);
      continue; // Skip if group or options are missing
    }

    // Handle both single and multiple selected options
    const selectedOptions = Array.isArray(selectedOptionIds)
      ? custItem.options.filter((option) => selectedOptionIds.includes(option.id.toString()))
      : custItem.options.filter((option) => option.id.toString() === selectedOptionIds.toString());

    // Map the selected options to addons and add quantity
    const updatedItems = selectedOptions.map((option) => ({
      ...option,
      qty: 1,
    }));

    // Add updated items to the addons array
    addons.push(...updatedItems);
  }

  // Construct parent item ID using SKU and selected addon IDs
  const parentItemIdArray = [props.data.sku_id];
  addons.forEach((item) => parentItemIdArray.push(item.id));

  // Add the item with addons to the cart
  cart.addItem({
    ...props.data,
    addons,
    parent_item_id: shortHash(parentItemIdArray.join('-')),
  });

  if (props.data.buynow) {
    await navigateTo({ path: '/cart' });
  } else {
    emit('close');  
  }
};
</script>